// extracted by mini-css-extract-plugin
export var container = "_c5-0";
export var icon = "_c5-1";
export var text = "_c5-2";